// src/components/features/timetables/Grid/Cell.tsx
import type { TimetableWaypointCell } from '../../../../data/useTimetable';
import { SvgIcon } from '../../../base/Icon/SvgIcon';
// styles
import styles from './TimetableGrid.module.css';

interface TimetableCellProps {
  cell?: TimetableWaypointCell;
}

function getRestrictionIconName(
  restriction: TimetableWaypointCell['restriction'],
) {
  // Icon ids intentionally mirror VisitRestriction values.
  switch (restriction) {
    case 'pickUpOnly':
      return 'pickUpOnly';
    case 'setDownOnly':
      return 'setDownOnly';
    default:
      return undefined;
  }
}

export function TimetableCell({ cell }: TimetableCellProps) {
  const iconName = getRestrictionIconName(cell?.restriction);

  return (
    <div className={styles.timeCellContent}>
      {/* Preserve the grid shape when a journey omits data for a waypoint. */}
      {cell?.displayTime ?? '--'}
      {iconName ? <SvgIcon name={iconName} size={16} /> : null}
    </div>
  );
}
